export default __webpack_public_path__ + "static/problems-62c5c968a68599c09ff86cce5661f493.webp";